module.exports = __webpack_public_path__ + "static/how-to-4@3x-9bb83fc85573e6c53617ec15062e3219.webp";